// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20000;
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background: rgba(0, 0, 0, 0.32);
  display: flex;
  justify-content: space-around;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/common/loading/loading.component.scss"],"names":[],"mappings":"AACA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,+BAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AAAD","sourcesContent":["\n.spinner-container {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 20000;\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\toutline: 0;\n\tbackground: rgba(0, 0, 0, 0.32);\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
